import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router";

// Assume these icons are imported from an icon library
import {
  BoxCubeIcon,
  CalenderIcon,
  ChatIcon,
  ChevronDownIcon,
  DocsIcon,
  GridIcon,
  HorizontaLDots,
  ListIcon,
  MailIcon,
  PageIcon,
  PieChartIcon,
  PlugInIcon,
  TableIcon,
  TaskIcon,
  UserCircleIcon,
  VideoIcon,
  CheckCircleIcon,
} from "../icons";
import { useSidebar } from "../context/SidebarContext";
import SidebarWidget from "./SidebarWidget";

type SubMenuItem = {
  name: string;
  path?: string;
  pro?: boolean;
  new?: boolean;
  subItems?: SubMenuItem[];
};

type NavItem = {
  name: string;
  icon: React.ReactNode;
  path?: string;
  subItems?: SubMenuItem[];
};

const token = localStorage.getItem("token");
// console.log("id in sidebar:", token);


// const navItems: NavItem[] = [
//   // {
//   //   icon: <GridIcon />,
//   //   name: "Dashboard",
//   //   subItems: [
//   //     { name: "Customer Surveys", path: "/", pro: false },
//   //     { name: "Ecommerce", path: "/", pro: false },
//   //     { name: "Analytics", path: "/analytics", pro: true },
//   //     { name: "Marketing", path: "/marketing", pro: true },
//   //     { name: "CRM", path: "/crm", pro: true },
//   //     { name: "Stocks", path: "/stocks", new: true, pro: true },
//   //   ],
//   // },
//   // {
//   //   icon: < TableIcon/>,
//   //   name: "Master Table",
//   //   subItems: [
//   //     { name: "Products", path: "/products", pro: false },
//   //   ],
//   // },
//   ...(token ? [
//     {
//       icon: <DocsIcon />,
//       name: "Daily Diary",
//       subItems: [
//         { name: "Customer Surveys", path:"/customer-surveys", pro: false },
//       ],
//     },
//     {
//       icon: <CheckCircleIcon />,
//       name: "Compliance Inspections",
//       subItems: [
//         { name: "Headings", path:"/headings", pro: false },
//       ],
//     },
//   ]:[]),
//   {
//     icon: <VideoIcon />,
//     name: "Training Videos",
//     subItems: [
//       { name: "Genie Introduction", path: "/hospitality-genie-introduction", pro: false },
//       { name: "Adding New User", path: "/user-accounts", pro: false },
//       { name: "Budget Function", path: "/budget-function", pro: false },
//       { name: "Compliance Function", path: "/compliance-function", pro: false },
//       { name: "WorkFlows Function", path: "/workflows-function", pro: false },
//       { name: "Creating Inventories and Stocktakes", path: "/creating-inventories-and-stocktakes", pro: false },
//       { name: "Intro Products and Suppliers", path: "/intro-products-and-suppliers", pro: false },
//       {
//         name: "Ordering Introduction",
//         subItems: [
//           { name: "Supplier Ordering", path:"/supplier-ordering" },
//           { name: "Delivery Processing Part 1", path: "/delivery-processing-1" },
//           { name: "Delivery Processing Part 2", path: "/delivery-processing-2" },
//         ],
//       },
//       {
//         name: "Supplier Portal",
//         subItems: [
//           { name: "Introduction Part 1", path: "/introduction-supplier-1" },
//           { name: "Introduction Part 2", path: "/introduction-supplier-2" },
//         ],
//       },
//     ],
//   },
//   // {
//   //   icon: <ListIcon />,
//   //   name: "Budgets",
//   //   path: "/budgets",
//   // },
//   // {
//   //   icon: <CalenderIcon />,
//   //   name: "Calendar",
//   //   path: "/calendar",
//   // },
//   // {
//   //   icon: <UserCircleIcon />,
//   //   name: "User Profile",
//   //   path: "/profile",
//   // },
//   // {
//   //   name: "Task",
//   //   icon: <TaskIcon />,
//   //   subItems: [
//   //     { name: "List", path: "/task-list", pro: true },
//   //     { name: "Kanban", path: "/task-kanban", pro: true },
//   //   ],
//   // },
//   // {
//   //   name: "Forms",
//   //   icon: <ListIcon />,
//   //   subItems: [
//   //     { name: "Form Elements", path: "/form-elements", pro: false },
//   //     { name: "Form Layout", path: "/form-layout", pro: true },
//   //   ],
//   // },
//   // {
//   //   name: "Tables",
//   //   icon: <TableIcon />,
//   //   subItems: [
//   //     { name: "Basic Tables", path: "/basic-tables", pro: false },
//   //     { name: "Data Tables", path: "/data-tables", pro: true },
//   //   ],
//   // },
//   // {
//   //   name: "Pages",
//   //   icon: <PageIcon />,
//   //   subItems: [
//   //     { name: "File Manager", path: "/file-manager", pro: true },
//   //     { name: "Pricing Tables", path: "/pricing-tables", pro: true },
//   //     { name: "Faqs", path: "/faq", pro: true },
//   //     { name: "Blank Page", path: "/blank", pro: true },
//   //     { name: "404 Error", path: "/error-404", pro: true },
//   //     { name: "500 Error", path: "/error-500", pro: true },
//   //     { name: "503 Error", path: "/error-503", pro: true },
//   //     { name: "Coming Soon", path: "/coming-soon", pro: true },
//   //     { name: "Maintenance", path: "/maintenance", pro: true },
//   //     { name: "Success", path: "/success", pro: true },
//   //   ],
//   // },
// ];

// const othersItems: NavItem[] = [
//   // {
//   //   icon: <PieChartIcon />,
//   //   name: "Charts",
//   //   subItems: [
//   //     { name: "Line Chart", path: "/line-chart", pro: true },
//   //     { name: "Bar Chart", path: "/bar-chart", pro: true },
//   //     { name: "Pie Chart", path: "/pie-chart", pro: true },
//   //   ],
//   // },
//   // {
//   //   icon: <BoxCubeIcon />,
//   //   name: "UI Elements",
//   //   subItems: [
//   //     { name: "Alerts", path: "/alerts", pro: false },
//   //     { name: "Avatar", path: "/avatars", pro: false },
//   //     { name: "Badge", path: "/badge", pro: true },
//   //     { name: "Breadcrumb", path: "/breadcrumb", pro: true },
//   //     { name: "Buttons", path: "/buttons", pro: true },
//   //     { name: "Buttons Group", path: "/buttons-group", pro: true },
//   //     { name: "Cards", path: "/cards", pro: true },
//   //     { name: "Carousel", path: "/carousel", pro: true },
//   //     { name: "Dropdowns", path: "/dropdowns", pro: true },
//   //     { name: "Images", path: "/images", pro: false },
//   //     { name: "Links", path: "/links", pro: true },
//   //     { name: "List", path: "/list", pro: true },
//   //     { name: "Modals", path: "/modals", pro: true },
//   //     { name: "Notification", path: "/notifications", pro: true },
//   //     { name: "Pagination", path: "/pagination", pro: true },
//   //     { name: "Popovers", path: "/popovers", pro: true },
//   //     { name: "Progressbar", path: "/progress-bar", pro: true },
//   //     { name: "Ribbons", path: "/ribbons", pro: true },
//   //     { name: "Spinners", path: "/spinners", pro: true },
//   //     { name: "Tabs", path: "/tabs", pro: true },
//   //     { name: "Tooltips", path: "/tooltips", pro: true },
//   //     { name: "Videos", path: "/videos", pro: false },
//   //   ],
//   // },
//   // {
//   //   icon: <PlugInIcon />,
//   //   name: "Authentication",
//   //   subItems: [
//   //     { name: "Sign In", path: "/signin", pro: false },
//   //     { name: "Sign Up", path: "/signup", pro: false },
//   //     { name: "Reset Password", path: "/reset-password", pro: true },
//   //     {
//   //       name: "Two Step Verification",
//   //       path: "/two-step-verification",
//   //       pro: true,
//   //     },
//   //   ],
//   // },
// ];

// const supportItems: NavItem[] = [
//   // {
//   //   icon: <ChatIcon />,
//   //   name: "Chat",
//   //   path: "/chat",
//   // },
//   // {
//   //   icon: <MailIcon />,
//   //   name: "Email",
//   //   subItems: [
//   //     { name: "Inbox", path: "/inbox" },
//   //     { name: "Details", path: "/inbox-details" },
//   //   ],
//   // },
//   // {
//   //   icon: <DocsIcon />,
//   //   name: "Invoice",
//   //   path: "/invoice",
//   // },
// ];

const AppSidebar: React.FC = () => {
  const { isExpanded, isMobileOpen, isHovered, setIsHovered } = useSidebar();
  const location = useLocation();
  
  // Read token inside component state so it re-renders when token changes
  const [token, setToken] = useState<string | null>(null);

  // Initialize token on component mount
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
    // console.log("Token in sidebar:", storedToken);
  }, []);


  // Listen for storage changes (if token gets updated)
  useEffect(() => {
    const handleStorageChange = () => {
      const storedToken = localStorage.getItem("token");
      setToken(storedToken);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Generate nav items dynamically based on current token state
  const navItems: NavItem[] = [
    // {
    //   icon: <GridIcon />,
    //   name: "Dashboard",
    //   subItems: [
    //     { name: "Customer Surveys", path: "/", pro: false },
    //     { name: "Ecommerce", path: "/ecommerce", pro: false },
    //     { name: "Analytics", path: "/analytics", pro: true },
    //     { name: "Marketing", path: "/marketing", pro: true },
    //     { name: "CRM", path: "/crm", pro: true },
    //     { name: "Stocks", path: "/stocks", new: true, pro: true },
    //   ],
    // },
    // {
    //   icon: < TableIcon/>,
    //   name: "Master Table",
    //   subItems: [
    //     { name: "Products", path: "/products", pro: false },
    //   ],
    // },
    ...(token ? [
      {
        icon: <DocsIcon />,
        name: "Daily Diary",
        subItems: [
          { name: "Customer Surveys", path:"/customer-surveys", pro: false },
        ],
      },
      {
        icon: <ListIcon />,
        name: "Menus",
        subItems: [
          { name: "Special Occasion Menus", path:"/special-occasion-menus", pro: false },
          { name: "Venue Outlets", path:"/venue-outlets", pro: false },
          { name: "Dietaries", path:"/dietaries", pro: false },
        ],
      },
      // {
      //   icon: <CheckCircleIcon />,
      //   name: "Compliance Inspections",
      //   subItems: [
      //     { name: "Headings", path:"/headings", pro: false },
      //     { name: "Inspections History", path:"/inspections-history", pro: false },
      //     { name: "Remedial Actions", path:"/remedial-actions", pro: false },
      //     { name: "Inspection Items", path:"/inspection-items", pro: false },
      //     { name: "Inspection Types", path:"/inspection-types", pro: false },
      //     { name: "Venue Areas", path:"/venue-areas", pro: false },
      //   ],
      // },
      // {
      //   icon: <TaskIcon />,
      //   name: "Workflows",
      //   subItems: [
      //     { name: "Daily Worksheet", path:"/daily-worksheet", pro: false },
      //     { name: "Workflows", path:"/workflows", pro: false },
      //     { name: "Tasks", path:"/tasks", pro: false },
      //     { name: "Look Up Tables", path:"/workflow-categories", pro: false,
      //       subItems: [
      //         { name: "Areas", path:"/areas", pro: false },
      //         { name: "Workflow Categories", path:"/workflow-categories", pro: false },
      //         { name: "Reasons Task Not Completed", path:"/reasons-task-not-completed", pro: false },
      //         { name: "Temperature Check Items", path:"/temperature-check-items", pro: false },
      //       ]
      //     },
      //   ],
      // }
    ]:[]),
    {
      icon: <VideoIcon />,
      name: "Training Videos",
      subItems: [
        { name: "Genie Introduction", path: "/hospitality-genie-introduction", pro: false },
        { name: "Adding New User", path: "/user-accounts", pro: false },
        { name: "Budget Function", path: "/budget-function", pro: false },
        { name: "Compliance Function", path: "/compliance-function", pro: false },
        { name: "WorkFlows Function", path: "/workflows-function", pro: false },
        { name: "Creating Inventories and Stocktakes", path: "/creating-inventories-and-stocktakes", pro: false },
        { name: "Intro Products and Suppliers", path: "/intro-products-and-suppliers", pro: false },
        {
          name: "Ordering Introduction",
          subItems: [
            { name: "Supplier Ordering", path:"/supplier-ordering" },
            { name: "Delivery Processing Part 1", path: "/delivery-processing-1" },
            { name: "Delivery Processing Part 2", path: "/delivery-processing-2" },
          ],
        },
        {
          name: "Supplier Portal",
          subItems: [
            { name: "Introduction Part 1", path: "/introduction-supplier-1" },
            { name: "Introduction Part 2", path: "/introduction-supplier-2" },
          ],
        },
      ],
    },
    // {
    //   icon: <ListIcon />,
    //   name: "Budgets",
    //   path: "/budgets",
    // },
    // {
    //   icon: <CalenderIcon />,
    //   name: "Calendar",
    //   path: "/calendar",
    // },
    // {
    //   icon: <UserCircleIcon />,
    //   name: "User Profile",
    //   path: "/profile",
    // },
    // {
    //   name: "Task",
    //   icon: <TaskIcon />,
    //   subItems: [
    //     { name: "List", path: "/task-list", pro: true },
    //     { name: "Kanban", path: "/task-kanban", pro: true },
    //   ],
    // },
    // {
    //   name: "Forms",
    //   icon: <ListIcon />,
    //   subItems: [
    //     { name: "Form Elements", path: "/form-elements", pro: false },
    //     { name: "Form Layout", path: "/form-layout", pro: true },
    //   ],
    // },
    // {
    //   name: "Tables",
    //   icon: <TableIcon />,
    //   subItems: [
    //     { name: "Basic Tables", path: "/basic-tables", pro: false },
    //     { name: "Data Tables", path: "/data-tables", pro: true },
    //   ],
    // },
    // {
    //   name: "Pages",
    //   icon: <PageIcon />,
    //   subItems: [
    //     { name: "File Manager", path: "/file-manager", pro: true },
    //     { name: "Pricing Tables", path: "/pricing-tables", pro: true },
    //     { name: "Faqs", path: "/faq", pro: true },
    //     { name: "Blank Page", path: "/blank", pro: true },
    //     { name: "404 Error", path: "/error-404", pro: true },
    //     { name: "500 Error", path: "/error-500", pro: true },
    //     { name: "503 Error", path: "/error-503", pro: true },
    //     { name: "Coming Soon", path: "/coming-soon", pro: true },
    //     { name: "Maintenance", path: "/maintenance", pro: true },
    //     { name: "Success", path: "/success", pro: true },
    //   ],
    // },
  ];

  const othersItems: NavItem[] = [
    // {
    //   icon: <PieChartIcon />,
    //   name: "Charts",
    //   subItems: [
    //     { name: "Line Chart", path: "/line-chart", pro: true },
    //     { name: "Bar Chart", path: "/bar-chart", pro: true },
    //     { name: "Pie Chart", path: "/pie-chart", pro: true },
    //   ],
    // },
    // {
    //   icon: <BoxCubeIcon />,
    //   name: "UI Elements",
    //   subItems: [
    //     { name: "Alerts", path: "/alerts", pro: false },
    //     { name: "Avatar", path: "/avatars", pro: false },
    //     { name: "Badge", path: "/badge", pro: true },
    //     { name: "Breadcrumb", path: "/breadcrumb", pro: true },
    //     { name: "Buttons", path: "/buttons", pro: true },
    //     { name: "Buttons Group", path: "/buttons-group", pro: true },
    //     { name: "Cards", path: "/cards", pro: true },
    //     { name: "Carousel", path: "/carousel", pro: true },
    //     { name: "Dropdowns", path: "/dropdowns", pro: true },
    //     { name: "Images", path: "/images", pro: false },
    //     { name: "Links", path: "/links", pro: true },
    //     { name: "List", path: "/list", pro: true },
    //     { name: "Modals", path: "/modals", pro: true },
    //     { name: "Notification", path: "/notifications", pro: true },
    //     { name: "Pagination", path: "/pagination", pro: true },
    //     { name: "Popovers", path: "/popovers", pro: true },
    //     { name: "Progressbar", path: "/progress-bar", pro: true },
    //     { name: "Ribbons", path: "/ribbons", pro: true },
    //     { name: "Spinners", path: "/spinners", pro: true },
    //     { name: "Tabs", path: "/tabs", pro: true },
    //     { name: "Tooltips", path: "/tooltips", pro: true },
    //     { name: "Videos", path: "/videos", pro: false },
    //   ],
    // },
    // {
    //   icon: <PlugInIcon />,
    //   name: "Authentication",
    //   subItems: [
    //     { name: "Sign In", path: "/signin", pro: false },
    //     { name: "Sign Up", path: "/signup", pro: false },
    //     { name: "Reset Password", path: "/reset-password", pro: true },
    //     {
    //       name: "Two Step Verification",
    //       path: "/two-step-verification",
    //       pro: true,
    //     },
    //   ],
    // },
  ];

  const supportItems: NavItem[] = [
    // {
    //   icon: <ChatIcon />,
    //   name: "Chat",
    //   path: "/chat",
    // },
    // {
    //   icon: <MailIcon />,
    //   name: "Email",
    //   subItems: [
    //     { name: "Inbox", path: "/inbox" },
    //     { name: "Details", path: "/inbox-details" },
    //   ],
    // },
    // {
    //   icon: <DocsIcon />,
    //   name: "Invoice",
    //   path: "/invoice",
    // },
  ];

  const [openSubmenu, setOpenSubmenu] = useState<{
    type: "main" | "support" | "others";
    index: number;
  } | null>(null);

  // independent nested menus; key includes menuType to avoid collisions
  const [openNested, setOpenNested] = useState<Record<string, boolean>>({});

  // measured heights for top-level submenu containers (to allow clip/animate)
  const [subMenuHeight, setSubMenuHeight] = useState<Record<string, number>>({});
  const subMenuRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const isActive = useCallback(
    (path?: string) => path && location.pathname === path,
    [location.pathname]
  );

  // If current path matches a submenu or nested item, open its parent main menu
  useEffect(() => {
    let submenuMatched = false;
    ["main", "support", "others"].forEach((menuType) => {
      const items =
        menuType === "main" ? navItems : menuType === "support" ? supportItems : othersItems;

      items.forEach((nav, index) => {
        if (nav.subItems) {
          nav.subItems.forEach((subItem) => {
            if (subItem.path && isActive(subItem.path)) {
              setOpenSubmenu({ type: menuType as "main" | "support" | "others", index });
              submenuMatched = true;
            }
            if (subItem.subItems) {
              subItem.subItems.forEach((nestedItem) => {
                if (nestedItem.path && isActive(nestedItem.path)) {
                  setOpenSubmenu({ type: menuType as "main" | "support" | "others", index });
                  submenuMatched = true;
                }
              });
            }
          });
        }
      });
    });

    if (!submenuMatched) {
      setOpenSubmenu(null);
    }
  }, [location.pathname, isActive]);

  // Recompute parent submenu container height whenever main submenu or nested state changes.
  // This fixes the case where nested expansion increases height but parent clipping wasn't updated.
  useEffect(() => {
    if (openSubmenu !== null) {
      const key = `${openSubmenu.type}-${openSubmenu.index}`;
      const el = subMenuRefs.current[key];
      if (el) {
        // Use requestAnimationFrame to measure after layout updates
        requestAnimationFrame(() => {
          setSubMenuHeight((prev) => ({ ...prev, [key]: el.scrollHeight || 0 }));
        });
      }
    }
  }, [openSubmenu, openNested, location.pathname]);

  const handleSubmenuToggle = (index: number, menuType: "main" | "support" | "others") => {
    setOpenSubmenu((prev) => {
      if (prev && prev.type === menuType && prev.index === index) return null;
      return { type: menuType, index };
    });
  };

  const handleNestedSubmenuToggle = (
    parentIndex: number,
    subIndex: number,
    menuType: "main" | "support" | "others"
  ) => {
    const nestedKey = `${menuType}-${parentIndex}-${subIndex}`;
    setOpenNested((prev) => {
      const next = { ...prev, [nestedKey]: !prev[nestedKey] };

      // After toggling nested, re-measure the parent submenu container
      // so it's tall enough to reveal the nested content.
      requestAnimationFrame(() => {
        const parentKey = `${menuType}-${parentIndex}`;
        const el = subMenuRefs.current[parentKey];
        if (el) {
          setSubMenuHeight((prevH) => ({ ...prevH, [parentKey]: el.scrollHeight || 0 }));
        }
      });

      return next;
    });
  };

  const renderSubItems = (
    items: SubMenuItem[],
    menuType: "main" | "support" | "others",
    parentIndex: number
  ) => {
    return (
      <ul className="mt-2 space-y-1 ml-9">
        {items.map((subItem, subIndex) => {
          const nestedKey = `${menuType}-${parentIndex}-${subIndex}`;
          const isNestedOpen = !!openNested[nestedKey];

          return (
            <li key={subItem.name}>
              {subItem.subItems ? (
                <>
                  <button
                    type="button"
                    onClick={() => handleNestedSubmenuToggle(parentIndex, subIndex, menuType)}
                    className={`menu-dropdown-item flex items-center w-full text-left ${
                      isNestedOpen ? "menu-dropdown-item-active" : "menu-dropdown-item-inactive"
                    }`}
                  >
                    <span>{subItem.name}</span>
                    <ChevronDownIcon
                      className={`ml-auto w-4 h-4 transition-transform ${
                        isNestedOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  <div
                    className="overflow-hidden transition-all duration-200"
                    style={{
                      height: isNestedOpen ? "auto" : "0px",
                    }}
                  >
                    <ul className="mt-1 space-y-1 ml-6">
                      {subItem.subItems.map((nestedItem) => (
                        <li key={nestedItem.name}>
                          {nestedItem.path && (
                            <Link
                              to={nestedItem.path}
                              className={`menu-dropdown-item pl-8 ${
                                isActive(nestedItem.path)
                                  ? "menu-dropdown-item-active"
                                  : "menu-dropdown-item-inactive"
                              }`}
                            >
                              {nestedItem.name}
                              <span className="flex items-center gap-1 ml-auto">
                                {nestedItem.new && (
                                  <span
                                    className={`ml-auto ${
                                      isActive(nestedItem.path)
                                        ? "menu-dropdown-badge-active"
                                        : "menu-dropdown-badge-inactive"
                                    } menu-dropdown-badge`}
                                  >
                                    new
                                  </span>
                                )}
                                {nestedItem.pro && (
                                  <span
                                    className={`ml-auto ${
                                      isActive(nestedItem.path)
                                        ? "menu-dropdown-badge-active"
                                        : "menu-dropdown-badge-inactive"
                                    } menu-dropdown-badge`}
                                  >
                                    pro
                                  </span>
                                )}
                              </span>
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              ) : (
                subItem.path && (
                  <Link
                    to={subItem.path}
                    className={`menu-dropdown-item ${
                      isActive(subItem.path)
                        ? "menu-dropdown-item-active"
                        : "menu-dropdown-item-inactive"
                    }`}
                  >
                    {subItem.name}
                    <span className="flex items-center gap-1 ml-auto">
                      {subItem.new && (
                        <span
                          className={`ml-auto ${
                            isActive(subItem.path)
                              ? "menu-dropdown-badge-active"
                              : "menu-dropdown-badge-inactive"
                          } menu-dropdown-badge`}
                        >
                          new
                        </span>
                      )}
                      {subItem.pro && (
                        <span
                          className={`ml-auto ${
                            isActive(subItem.path)
                              ? "menu-dropdown-badge-active"
                              : "menu-dropdown-badge-inactive"
                          } menu-dropdown-badge`}
                        >
                          pro
                        </span>
                      )}
                    </span>
                  </Link>
                )
              )}
            </li>
          );
        })}
      </ul>
    );
  };

  const renderMenuItems = (items: NavItem[], menuType: "main" | "support" | "others") => (
    <ul className="flex flex-col gap-4">
      {items.map((nav, index) => {
        const key = `${menuType}-${index}`;
        const isOpen = openSubmenu?.type === menuType && openSubmenu?.index === index;
        const measuredHeight = subMenuHeight[key] ?? 0;

        return (
          <li key={nav.name}>
            {nav.subItems ? (
              <button
                type="button"
                onClick={() => handleSubmenuToggle(index, menuType)}
                className={`menu-item group ${
                  isOpen ? "menu-item-active" : "menu-item-inactive"
                } cursor-pointer ${!isExpanded && !isHovered ? "lg:justify-center" : "lg:justify-start"}`}
              >
                <span className={`${isOpen ? "menu-item-icon-active" : "menu-item-icon-inactive"}`}>
                  {nav.icon}
                </span>
                {(isExpanded || isHovered || isMobileOpen) && <span className="menu-item-text">{nav.name}</span>}
                {(isExpanded || isHovered || isMobileOpen) && (
                  <ChevronDownIcon
                    className={`ml-auto w-5 h-5 transition-transform duration-200 ${isOpen ? "rotate-180 text-[#142900]" : ""}`}
                  />
                )}
              </button>
            ) : (
              nav.path && (
                <Link to={nav.path} className={`menu-item group ${isActive(nav.path) ? "menu-item-active" : "menu-item-inactive"}`}>
                  <span className={`${isActive(nav.path) ? "menu-item-icon-active" : "menu-item-icon-inactive"}`}>{nav.icon}</span>
                  {(isExpanded || isHovered || isMobileOpen) && <span className="menu-item-text">{nav.name}</span>}
                </Link>
              )
            )}

            {/* Top-level submenu container (clipped when closed). */}
            {nav.subItems && (isExpanded || isHovered || isMobileOpen) && (
              <div
                ref={(el) => {
                  subMenuRefs.current[key] = el;
                }}
                className="overflow-hidden transition-all duration-300"
                style={{
                  height: isOpen ? `${measuredHeight}px` : "0px",
                }}
              >
                {renderSubItems(nav.subItems, menuType, index)}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );

  return (
    <aside
      className={`fixed mt-16 flex flex-col lg:mt-0 top-0 px-5 left-0 bg-[#142900] dark:bg-gray-900 dark:border-gray-800 text-gray-900 h-screen transition-all duration-300 ease-in-out z-50 border-r border-gray-200 
        ${isExpanded || isMobileOpen ? "w-[290px]" : isHovered ? "w-[290px]" : "w-[90px]"}
        ${isMobileOpen ? "translate-x-0" : "-translate-x-full"}
        lg:translate-x-0`}
      onMouseEnter={() => !isExpanded && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={`py-8 flex ${!isExpanded && !isHovered ? "lg:justify-center" : "justify-start"}`}>
        <Link to="/">
          {isExpanded || isHovered || isMobileOpen ? (
            <>
              <img className="dark:hidden" src="/images/logo/GenieLogo.svg" alt="Logo" width={160} height={50} />
              <img className="hidden dark:block" src="/images/logo/logo-dark.svg" alt="Logo" width={150} height={40} />
            </>
          ) : (
            <img src="/images/logo/GenieLogoFavicon.svg" alt="Logo" width={37} height={32} />
          )}
        </Link>
      </div>

      <div className="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar">
        <nav className="mb-6">
          <div className="flex flex-col gap-4">
            <div>
              <h2 className={`mb-4 text-xs uppercase flex leading-[20px] text-gray-400 ${!isExpanded && !isHovered ? "lg:justify-center" : "justify-start"}`}>
                {isExpanded || isHovered || isMobileOpen ? "Menu" : <HorizontaLDots />}
              </h2>
              {renderMenuItems(navItems, "main")}
            </div>

            <div>{renderMenuItems(supportItems, "support")}</div>
            <div>{renderMenuItems(othersItems, "others")}</div>
          </div>
        </nav>

        {isExpanded || isHovered || isMobileOpen ? <SidebarWidget /> : null}
      </div>
    </aside>
  );
};

export default AppSidebar;
